module.exports = __webpack_public_path__ + "static/MI-0000ee5d54ecb473f314893b1b59e426.jpg";